import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

@Component({
  selector: "nav-panel",
  templateUrl: "./nav-panel.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  // The host takes keyboard focus (routerLink gives it a tabindex), so it carries the rounded corners
  // the focus outline follows — without them it drew a square box inside the rounded cards. Only
  // while focused: at rest a rounded corner would curl the ends of a row's border-bottom divider.
  // Block, so the outline wraps the row as one box rather than per inline fragment.
  host: { class: "tw-block focus-visible:tw-rounded-xl" },
})
export class NavPanelComponent {
  onClick = output<void>();
  title = input<string>("");
  iconName = input<string>("");
  toggleEnabled = input<boolean>(false);
  toggleChange = output<boolean>();
  stackLayout = input<boolean>(false);
  storageLayout = input<boolean>(false);
  showToggle = input<boolean>(false);
}
